var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgFolderOpen = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    viewBox: "0 0 16 16",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#42586E",
    fillRule: "evenodd",
    d: "M8 11.334c-.337 0-.66-.156-.884-.428l-2.809-3.4c-.336-.407-.403-.985-.172-1.473.203-.432.608-.7 1.056-.7h5.618c.448 0 .853.268 1.056.7.231.488.164 1.066-.172 1.473l-2.809 3.4c-.224.272-.547.428-.884.428z",
    clipRule: "evenodd"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgFolderOpen, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/folder_open.52a6cb06.svg";
export { ForwardRef as ReactComponent };